import styled, { css } from 'styled-components';
import { colors } from '../../config/styles';
import { globalFormat } from '../../utils/formatting';
import KubitModal from '../KubitModal';
import { IUploadState, UploadStateType } from './types';

interface IProps {
  uploadState: IUploadState;
  onCancel: () => void;
}

const Text = styled.div<{ $error?: boolean }>`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  ${({ $error }) =>
    $error &&
    css`
      color: ${colors.mainError};
    `}
`;

const UploadStateModal = ({ uploadState, onCancel }: IProps) => {
  const handleClose = () => {
    if (
      uploadState.type === UploadStateType.UPLOADING ||
      uploadState.type === UploadStateType.ERROR
    ) {
      onCancel();
    }
  };

  return (
    <KubitModal open={true} onClose={handleClose}>
      <Text $error={uploadState.type === UploadStateType.ERROR}>
        {uploadState.type === UploadStateType.PREPARING && (
          <>Preparing for upload...</>
        )}
        {uploadState.type === UploadStateType.UPLOADING && (
          <>
            Uploading:{' '}
            {globalFormat.formatNumber(uploadState.progress / 100, {
              style: 'percent',
              decimalPlace: 0,
            })}
          </>
        )}
        {uploadState.type === UploadStateType.ERROR && uploadState.message}
      </Text>
    </KubitModal>
  );
};

export default UploadStateModal;
